import createDataContext from './createDataContext';
import api from '../api/api';

const specialOfferReducer = (state, action) => {
	switch (action.type) {
		case 'LOAD_SPECIALOFFER_REQUEST':
			return {
				...state,
				loading: true,
				error: false,
			};
		case 'LOAD_SPECIALOFFER_SUCCESS':
			return {
				...state,
				loading: false,
				specialOffer: action.payload,
			};
		case 'LOAD_SPECIALOFFER_ERROR':
			return {
				...state,
				loading: false,
				error: 'Unable to load special offer',
			};
		default:
			return state;
	}
};

const loadSpecialOffer = (dispatch) => async (id) => {
	try {
		dispatch({
			type: 'LOAD_SPECIALOFFER_REQUEST',
		});
		const response = await api.get(`/specialOffers/${id}`);
		dispatch({
			type: 'LOAD_SPECIALOFFER_SUCCESS',
			payload: response.data,
		});
	} catch (e) {
		dispatch({
			type: 'LOAD_SPECIALOFFER_ERROR',
		});
	}
};

export const { Context, Provider } = createDataContext(
	specialOfferReducer,
	{
		loadSpecialOffer,
	},
	{
		specialOffer: {},
		error: '',
		loading: false,
	}
);
